import React from 'react';
import { SvgIconProps } from '@mui/material';

export const HomeIcon: React.FC<SvgIconProps> = (props) => (
    <svg
        width="28"
        height="33"
        viewBox="0 0 28 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M26.0833 13.9167L26.0833 31.8333H1.00001L1 13.9167L13.5417 1.375L19.8125 7.64583"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default HomeIcon;
